import { i18n } from "@/main";

const getAllFacilitiesLabel = () => {
  return i18n.t("message.reviews.categories.allFacilities");
};

const getDetailedDisplayName = (displayName, storeCode, address) => {
  const separator = ' <span class="separator">|</span> ';
  const addressLabel = `${i18n.t("message.common.address")} ${address}`;
  const storeCodeLabel = `${i18n.t("message.common.storeCode")} ${storeCode}`;
  return [displayName, addressLabel, storeCodeLabel].join(separator);
};

const getDisplayNameFromObject = displayName => {
  const gmbAddressName = displayName.gmbAddressName;
  const address = displayName.address;
  const secondaryTextClass = `<span class="grid-secondary-text">${secondaryTextClass}${address}</span>`;

  return `${gmbAddressName}<br />${secondaryTextClass}`;
};

export default {
  getBasicParams: state => {
    return { ...state.selectedFacility.params, ...state.selectedDate } || {};
  },
  getComparisonParams: state => {
    return { ...state.selectedFacility.params, ...state.comparisonDate } || {};
  },
  getFacilityParams: state => {
    return state.selectedFacility.params;
  },
  getSelectedDate: state => {
    return state.selectedDate;
  },
  getComparisonDate: state => {
    return state.comparisonDate;
  },
  isComparing: state => {
    return state.isComparing;
  },
  getSelectedFacilityParams: state => {
    return state.selectedFacility.params || {};
  },
  getSelectedFacilityMeta: state => {
    return state.selectedFacility.meta || {};
  },
  getFacilityDisplayName: state => {
    const { meta } = state.selectedFacility;
    const { displayName, storeCode, address } = meta || {};
    if (!displayName) {
      return getAllFacilitiesLabel();
    }

    if (typeof displayName !== "string") {
      return getDisplayNameFromObject(displayName);
    }

    if (displayName && storeCode && address) {
      return getDetailedDisplayName(displayName, storeCode, address);
    }

    return displayName;
  },

  getFacilityCount: state => {
    return state.selectedFacility.meta
      ? state.selectedFacility.meta.quantity
      : 0;
  },
  getSelectedApps: state => {
    return state.selectedApps;
  }
};
